















import { defineComponent, ref } from '@nuxtjs/composition-api';

export default defineComponent({
    components: {

    },
    props: {
        rebate: {},
    },
    setup(props) {
        const showRebate = ref(false);

        return {
            showRebate,
        };
    },
});
